import { MakerCard } from '@app/components/MakerCard';
import { AllManufacturersQueryResult } from '@app/sanity.types';
import styles from '@styles/Maker/makers.module.scss';
import Link from 'next/link';
import React, { FC } from 'react';

type ItemManufacture = AllManufacturersQueryResult[number];
type Props = {
  letter: string;
  items: ItemManufacture[];
};

const MakersWrapper: FC<Props> = ({ letter, items }) => (
  <div className={styles.container} id={`maker-${letter}`}>
    <div className={styles.container__header}>
      {/*
        The letter is this section's heading, so it is an `<h2>` under the page `<h1>` — as an
        `<h3>` it left a level gap that Seobility counted as a structural problem on /maker, and it
        put the manufacturer cards' own `<h3>`s at the wrong depth (MDC-4221). The count beside it
        labels the section rather than heading anything, so it is no longer a heading at all.
        Both classes carry their own type styles, so neither change alters what renders.
      */}
      <h2 className={styles.header__letter}>{letter}</h2>
      <span className={styles.header__count}>({items.length})</span>
    </div>

    <ul className={styles.container__items}>
      {items
        .filter((maker) => maker.slug?.current)
        .map((maker) => (
          <Link key={maker._id} href={`/maker/${maker.slug.current}`}>
            <MakerCard maker={maker} />
          </Link>
        ))}
    </ul>
  </div>
);

export default MakersWrapper;
